import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { ClassRegister } from '../../shared/class-register.entity';
import { Course } from '../../shared/course.entity';
import { HomeworkDto } from '../../shared/homework.dto';

@Component({
    selector: 'app-class-analyses-homework',
    templateUrl: './class-analyses-homework.component.html',
    styleUrls: ['./class-analyses-homework.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClassAnalysesHomeworkComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    classRegister: ClassRegister;
    courses: Course[];
    homework: HomeworkDto[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.classRegister = await this.service.restGetClassRegister(this.id, ["timetableEntries"], null, true);
        this.courses = await RestEndpoint.main().query({ year: this.classRegister.enaioSchoolClass.getYearNumber(), isHalfYear: this.classRegister.isHalfYear, grade: this.classRegister.enaioSchoolClass.grade, schoolType: this.classRegister.enaioSchoolClass.getSchoolType() }).run("api/cer/classregister/courses").list(Course);
        this.homework = await RestEndpoint.main().query({id: this.id}).run("api/cer/classregister/homework").list(HomeworkDto);

        this.table = new TableData([
            new TableColumn("date", "Datum", TableCellType.date, 1),
            new TableColumn("hour", "Stunde", TableCellType.int, 2),
            new TableColumn("domain", "Fach", TableCellType.string, 20),
            new TableColumn("homework", "Hausaufgaben", TableCellType.string, -1)
        ], this.homework.map(hw => new TableRow("", hw, {
            date: hw.date,
            hour: hw.hour + 1,
            domain: hw.courseId > 0 ? Arrays.findAndConvert(this.courses, c => c.id == hw.courseId, c => c.title, "<Unbekannter Kurs>") : hw.domain,
            homework: hw.homework
        })), [new TableSortColumn("date", false), new TableSortColumn("hour", false)]);

        await this.service.updateNavigationClassRegister(this.id, [
            { label: "Auswertungen", routerLink: ["/enaio-certificates", "class-registers", "analyses", this.id] },
            { label: "Übersicht von Hausaufgaben", routerLink: ["/enaio-certificates", "class-registers", "analyses", "homework", this.id] }
        ]);
        return true;
    }

    async selectRow(event: any): Promise<void> {
        await this.app.navigateTo(["/enaio-certificates", "class-registers", "lesson", (event.raw as HomeworkDto).lessonId, this.classRegister.id]);
    }
}
